export enum ElementsList {
    DOWNLOAD_ALL = 'Download All',
    CREATE_NEW = 'Create Now',
    UPGRADE_NOW = 'Upgrade Now',
    PRO_PACKAGE_DETAILS = 'Pro Package Details',
    UPGRADE_PRO_LOGO = 'Upgrade My Logo',
    DOWNLOAD_SAMPLE_KIT = 'Download Sample Kit',
    HOW_FIVERR_WORKS = 'How Fiverr Works',
    SELLER_NAME = 'Seller Name',
    GIGS_CAROUSEL = 'Gigs Carousel',
    QUIZ_PROJECT = 'Quiz Project',
    QUIZ_PROJECT_SERVICE = 'Quiz Project service',
    QUIZ_EDIT_PROJECT = 'Quiz Edit Project List',
    QUIZ_CONTINUE = 'Quiz Continue',
    NEW_LOGO = 'New logo',
    SPECIAL_VARIATION = 'Special Variation',
    GET_APP = 'Get App',
}

export enum VariationType {
    XMAS22_VARIATION = 'XMAS22',
    UA_VARIATION = 'UA',
}

type QuizProjectPayload = {
    element: ElementsList.QUIZ_PROJECT;
    payload?: {
        action: string;
        projectName: string;
    };
};

type QuizProjectServicePayload = {
    element: ElementsList.QUIZ_PROJECT_SERVICE;
    payload?: {
        serviceName: string;
    };
};

type NewLogoPayload = {
    element: ElementsList.NEW_LOGO;
    payload?: {
        newBrandName: string;
    };
};

type CreateNewVariationPayload = {
    element: ElementsList.CREATE_NEW;
    payload?: {
        isFree: boolean;
    };
};

type SpecialVariationPayload = {
    element: ElementsList.SPECIAL_VARIATION;
    payload?: {
        variationType: VariationType;
    };
};

type EventWithPayload =
    | QuizProjectPayload
    | QuizProjectServicePayload
    | NewLogoPayload
    | CreateNewVariationPayload
    | SpecialVariationPayload;

type EventWithoutPayload = {
    element: Exclude<ElementsList, EventWithPayload['element']>;
};

export type ReportClickPayload = EventWithPayload | EventWithoutPayload;
